import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/contexto/AuthContexto';
import api from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle, AlertTriangle, Loader2 } from 'lucide-react';

export default function VerificarEmail() {
  const [params] = useSearchParams();
  const { cerrarSesion } = useAuth();
  const token = params.get('token');
  const [estado, setEstado] = useState('verificando');

  useEffect(() => {
    if (!token) { setEstado('error'); return; }
    api.get(`/auth/verificar-email?token=${token}`)
      .then(() => {
        setEstado('exito');
        // Clear any existing session so user goes to clean login
        cerrarSesion();
      })
      .catch(() => setEstado('error'));
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4">
      <Card className="bg-slate-900/80 border-slate-800 max-w-md w-full">
        <CardContent className="p-8 text-center">
          {estado === 'verificando' && (
            <>
              <Loader2 className="w-12 h-12 text-amber-500 animate-spin mx-auto mb-4" />
              <h2 className="font-barlow text-xl font-bold text-slate-50">Verificando tu correo...</h2>
            </>
          )}
          {estado === 'exito' && (
            <>
              <div className="w-16 h-16 rounded-full bg-emerald-500/20 flex items-center justify-center mx-auto mb-5">
                <CheckCircle className="w-8 h-8 text-emerald-400" />
              </div>
              <h2 className="font-barlow text-2xl font-bold text-slate-50 mb-3">Correo Verificado</h2>
              <p className="text-slate-400 text-sm mb-6">Tu correo ha sido verificado exitosamente.</p>
              <Link to="/login">
                <Button className="bg-amber-500 hover:bg-amber-600 text-black font-bold" data-testid="ir-login-verificado-btn">
                  Ir al Login
                </Button>
              </Link>
            </>
          )}
          {estado === 'error' && (
            <>
              <div className="w-16 h-16 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-5">
                <AlertTriangle className="w-8 h-8 text-red-400" />
              </div>
              <h2 className="font-barlow text-2xl font-bold text-slate-50 mb-3">Enlace Invalido</h2>
              <p className="text-slate-400 text-sm mb-6">El enlace de verificacion es invalido o ya fue usado.</p>
              <Link to="/login">
                <Button className="bg-amber-500 hover:bg-amber-600 text-black font-bold" data-testid="ir-login-error-btn">
                  Ir al Login
                </Button>
              </Link>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
